import { useState } from 'react';
import { Box, Stack, TextField, Button, Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import { isValidPhoneNumber, parsePhoneNumber, getCountryCallingCode } from 'libphonenumber-js';
import type { CountryCode } from 'libphonenumber-js';
import { autoWebViewJs } from '@droid/android';

// 常用国家列表，可根据实际需求扩展
const COUNTRY_LIST: { code: CountryCode; name: string }[] = [
  { code: 'CN', name: '中国' },
  { code: 'US', name: '美国' },
  { code: 'GB', name: '英国' },
  { code: 'IN', name: '印度' },
  { code: 'JP', name: '日本' },
  { code: 'KR', name: '韩国' },
  { code: 'DE', name: '德国' },
  { code: 'FR', name: '法国' },
  { code: 'RU', name: '俄罗斯' },
  { code: 'BR', name: '巴西' },
];

// 生成短信发送脚本
function runSendSmsScript(msg: string, targetNumber: string, senderNumber?: string, simSlot?: number) {
  const script = `com.fanfanlo.lib.sms.SmsSender.sendSms("${targetNumber}", "${msg}", "${senderNumber || ''}", ${simSlot || 0}, true, "", function(){java.lang.System.out.println('321 sms sent')})`;
  autoWebViewJs.callScript(script);
}

// 手机号校验
function validatePhoneNumber(input: string, defaultCountry: CountryCode) {
  let number = input.trim();
  if (!number) return false;
  if (!number.startsWith('+')) {
    try {
      const phoneNumber = parsePhoneNumber(number, defaultCountry);
      return phoneNumber.isValid();
    } catch {
      return false;
    }
  } else {
    return isValidPhoneNumber(number);
  }
}

export function SendSms() {
  const [msg, setMsg] = useState('can you hear me');
  const [targetNumber, setTargetNumber] = useState('16553511099');
  const [senderNumber, setSenderNumber] = useState('13121129569');
  const [country, setCountry] = useState<CountryCode>('CN');
  const [targetNumberError, setTargetNumberError] = useState('');
  const [senderNumberError, setSenderNumberError] = useState('');

  function handleTargetNumberChange(e: any) {
    const v = e.target.value;
    setTargetNumber(v);
    if (!validatePhoneNumber(v, country)) {
      setTargetNumberError('目标手机号格式无效');
    } else {
      setTargetNumberError('');
    }
  }

  function handleSenderNumberChange(e: any) {
    const v = e.target.value;
    setSenderNumber(v);
    if (v && !validatePhoneNumber(v, country)) {
      setSenderNumberError('发件人手机号格式无效');
    } else {
      setSenderNumberError('');
    }
  }

  function sendSms() {
    if (!validatePhoneNumber(targetNumber, country)) {
      setTargetNumberError('目标手机号格式无效');
      return;
    }
    if (senderNumber && !validatePhoneNumber(senderNumber, country)) {
      setSenderNumberError('发件人手机号格式无效');
      return;
    }
    // TODO: 调用原有发送逻辑
    // alert('手机号校验通过，可以发送短信');
    const script = runSendSmsScript(msg, targetNumber, senderNumber);
    // ...
  }

  return (
    <Box>
      <Stack direction="column" spacing={2}>
        <Box className="abcedfg">
          <FormControl sx={{mt:"0.5rem"}}>
            <InputLabel id="country-label">国家</InputLabel>
            <Select
              labelId="country-label"
              value={country}
              label="国家"
              onChange={e => setCountry(e.target.value as CountryCode)}
              sx={{ width: 180 }}
            >
              {COUNTRY_LIST.map(item => (
                <MenuItem key={item.code} value={item.code}>
                  {item.name} (+{getCountryCallingCode(item.code as CountryCode)})
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
        <TextField
          label="目标手机号"
          value={targetNumber}
          onChange={handleTargetNumberChange}
          error={!!targetNumberError}
          helperText={targetNumberError || '请输入国际格式或本地格式手机号'}
        />
        <TextField
          label="发件人手机号（可选）"
          value={senderNumber}
          onChange={handleSenderNumberChange}
          error={!!senderNumberError}
          helperText={senderNumberError || '如需指定发件人，可填写'}
        />
        <TextField
          label="短信内容"
          value={msg}
          onChange={e => setMsg(e.target.value)}
          multiline
          rows={3}
        />
        <Button
          variant="contained"
          onClick={sendSms}
          disabled={
            !targetNumber || !!targetNumberError || !!senderNumberError || !msg
          }
        >
          发送短信
        </Button>
      </Stack>
    </Box>
  );
}